import React, { useEffect, useState } from "react";
import { useQuoteStore } from "src/hooks/quote";
import QuoteConfig from "@system/config/quote";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useBOMStore } from "src/hooks/bom";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import { useSystem } from "src/hooks/system";

const ValidateRFQQuoteRequest = (props) => {
  const [__check] = useAxiosIndicatorCheck();
  const { data, SetStatus } = props;
  const [selectedQuoteList, SetSelectedQuoteList] = useState([]);
  const [{}, {}, { add_multiple_quote }] = useQuoteStore();
  const [
    { bom_detail_by_bom_id, bom_detail_by_bom_id_type, bom_project_list },
  ] = useBOMStore();
  const [{}, { get_inventory_by_id, get_pricing_by_id }, {}] =
    useProductInventoryPriceStore();
  const quoteFrom = data.quoteFrom;
  const quoteList = data.quoteList;
  const addQuoteList = data.addQuote;
  const [loader, setLoader] = useState(false);
  const [,{ get_quantity_format }] = useSystem();

  async function getQuoteData() {
    if (quoteFrom === "BOMQuote") {
      await add_multiple_quote({ quoteList, quoteFrom });
      SetSelectedQuoteList(quoteList);
      addQuoteEvent();
    }
  }

  useEffect(() => {
    if (data) {
      getQuoteData();
    }
  }, [data]);

  const onReviewQuote = async () => {
    setLoader(true);
    window.location.href = QuoteConfig.getQuoteRouteURL();
    SetStatus(false);
    setLoader(false);
  };

  //By Ramya Kannan [Add to quote - Adobe script ]
  function addQuoteEvent() {
    let eventType;
    if (quoteFrom === "BOMQuote") {
      eventType = "addToQuoteFromBOM";
    } else {
      eventType = "addToQuote";
    }
    localStorage.setItem("adobeEventType", eventType);
    let copyProd = addQuoteList;
    let prodDetails = [];
    let getBomDetails = bom_detail_by_bom_id;
    let bomDetails = { ...getBomDetails };
    if (bom_project_list) {
      bomDetails.projectName =
        bom_project_list[bom_detail_by_bom_id.projectId]?.projectName;
    }
    bomDetails.exactMatchCount = bom_detail_by_bom_id_type?.Exact?.count;
    bomDetails.nomatchCount = bom_detail_by_bom_id_type?.NoMatch?.count;
    bomDetails.multipleMatchCount = bom_detail_by_bom_id_type?.Multiple?.count;
    console.log("copyProd",copyProd)
    console.log("quoteList",quoteList)
    copyProd.map((data,i)=>{
        let cpyData = {...data};
        cpyData.qas = get_inventory_by_id(data.ItemNumber)?.inventoryQty || 0;
        let priceVal = getPricing(data);
        cpyData.priceSource = priceVal?.priceSource;
        cpyData.unitPrice = cpyData.unitPrice || priceVal?.marketPrice;
        cpyData.subtotal = cpyData.subtotal || (priceVal?.marketPrice * priceVal?.quantity);
        cpyData.quantity = quoteList[i].quantity1;
        cpyData.quoteID= quoteList[i].quoteLineItemId,
        prodDetails.push(cpyData);
    })
    
    let cartDetails = {
      cartType: "Quote",
      additionSource: quoteFrom,
      quoteType: "online",
    };
    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({
        prodDetails,
        cartDetails,
        bomDetails,
      });
    }
  }

  const getPricing = (ele) => {
    let priceValues = get_pricing_by_id({
      uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber,
    });
    return priceValues && priceValues[0];
  };

  return (
    <>
      <div className="avnet-modal modal-600">
        <div className="avnet-modal-inner">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => SetStatus(false)}
          >
            ×
          </button>
          <div className="modal-header border-0">
            <h3 className="modal-title m-auto" id="exampleModalLabel">
              Request a Quote
            </h3>
          </div>
          <div className="modal-body">
            {__check(["QUOTE_API_CALL"]).render}
            {!__check(["QUOTE_API_CALL"]).status && (
              <>
                <div className="m-b-10">
                  <b>Quote Number: </b> Open
                </div>
                <table className="table border-1">
                  <thead>
                    <tr className="bg-grey2">
                      <th>Part Number/Manufacturer </th>
                      <th>Quote Qty</th>
                    </tr>
                    <tr></tr>
                  </thead>

                  <tbody>
                    {Object.values(selectedQuoteList).map((v, i) => (
                      <tr key={i}>
                        <td>
                          <strong>{v.ERPMFRPartNumber}</strong>
                          <div>By {v.manufacturerName}</div>
                        </td>
                        <td>
                          {get_quantity_format(v.quantity1)}
                          <div className="mt-2 mb-2">——</div>
                          <div className="mt-2 mb-2">——</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="text-center ps-2 pe-2 font-13 font-arial">
                  <b className="d-block">You're almost done!</b>
                  Click "<b>Review Quote</b>" to go to "My Open Quotes" to
                  complete submitting this part for a quotation response. If you
                  continue shopping you can always go to "My Open Quotes" in
                  your Dashboard to complete submitting this part.
                </div>
              </>
            )}
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              type="button"
              className="bs5 btn btn-secondary"
              disabled={loader}
              onClick={() => SetStatus(false)}
            >
              Continue Shopping
            </button>
            <button
              disabled={loader}
              type="button"
              className="bs5 btn btn-primary w145"
              onClick={onReviewQuote}
            >{loader ? <i className="fa fa-spinner fa-spin "/> : "Review Quote"}</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ValidateRFQQuoteRequest;
